import React, { useState } from 'react';
import { MenuItem, makeStyles, useTheme } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import {
    Translation
} from '../../features/translations/getTranslation'

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: "100%",
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(key, label, theme) {
    return {
        fontWeight:
            label.indexOf(key) === ""
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export const MultipleSelect = (props) => {
    const classes = useStyles()
    const theme = useTheme()
    const [value, setValue] = useState(props.value != null && typeof (props.value) == "string" ? props.value.split(",") : (props.value ?? []))
    const idField = props.Id ?? "Id"
    const labelField = props.Label ?? "Label"

    const handleChange = (event) => {
        const { target: { value } } = event;
        setValue(typeof value === 'string' ? value.split(',') : value)
        props.onChange(value)
    }

    var selectOptions = [];

    if (props.items != undefined) {
        props.items.forEach((item) => {
            selectOptions.push({ ...item, Label: Translation.t(item.Label) });
        });
    }

    return (
        <FormControl className={classes.formControl}>
            <Select
                labelId="demo-mutiple-chip-label"
                id="demo-mutiple-chip"
                multiple
                value={value}
                onChange={handleChange}
                disabled={props.readonly}
                renderValue={(selected) => (
                    <div className={classes.chips}>
                        {selected.map((Id) => {
                            const item = selectOptions.filter(x => x[idField] == `${Id}`)[0];
                            if (item == '' || item == null) return
                            return (
                                <Chip key={Id} label={item[labelField]} className={classes.chip} />
                            )
                        })}
                    </div>
                )}
                MenuProps={MenuProps}
            >
                {selectOptions.map((obj) => {
                    const Id = `${obj[idField]}`;
                    const Label = obj[labelField];
                    return (<MenuItem key={Id} value={Id} style={getStyles(Id, Label, theme)}>
                        <Checkbox checked={value.includes(Id)} style={{ color: '#1cabe2' }} />
                        <ListItemText primary={Label} />
                    </MenuItem>)
                })}
            </Select>
            {props.error ? <p className="errorMessage">{Translation.t(props.error)}</p> : null}
        </FormControl>
    );
}